<template lang="pug">
  .form
    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors['school_info.region'] }"
      )
        .form-elem__title Регион
        .form-elem__body
          multiselect.custom-multiselect(
            v-model="schoolRegion"
            placeholder="Выберите регион",
            :options="regionsList"
            :label="'value'"
            :multiple="false"
            :showLabels="false"
            :closeOnSelect="true"
            :allowEmpty="true"
            :clearOnSelect="false"
            @search-change="asyncFindSchoolRegion"
          )
            template(
              slot="noOptions"
            ) Начните вводить название региона
            template(
              slot="noResult"
            ) Ничего не найдено
    .form__elem(
      v-if="showArea"
    )
      .form-elem.form-elem_horizontal(
        :class="{'form-elem_error' : requireErrors['school_info.area']}"
      )
        .form-elem__title Район
        .form-elem__body
          multiselect.custom-multiselect(
          v-model="localSchoolInfo.area"
          placeholder="Выберите район",
          :options="areasList"
          :multiple="false"
          :showLabels="false"
          :closeOnSelect="true"
          :allowEmpty="true"
          @select="keymonitor"
          )
            template(
            slot="noOptions"
            ) Список пуст
            template(
            slot="noResult"
            ) Ничего не найдено

    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors['school_info.school'] }"
      )
        .form-elem__title Школа
        .form-elem__body
          input.input.input_full(
          v-model="localSchoolInfo.school"
          v-on:keyup="keymonitor"
          maxlength=50
          )
    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors['school_info.class'] }"
      )
        .form-elem__title Класс
        .form-elem__body
          input.input.input_full(
            v-model="localSchoolInfo.class"
            v-on:keyup="keymonitor"
            maxlength=50
          )
    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors['school_info.class_profile'] }"
      )
        .form-elem__title Профиль класса
        .form-elem__body
          input.input.input_full(
            v-model="localSchoolInfo.class_profile"
            v-on:keyup="keymonitor"
            maxlength=50
          )
    .form__elem.form__elem_full
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : requireErrors.school_certificate_attachments }"
      )
        .form-elem__title Справка из школы
        .form-elem__body
          attach-file(
          :attachments="localSchoolCertificateAttachments"
          attachment-type="school_certificate_attachments"
          fieldname="school_certificate_attachments"
          @onChangeAttachments="changeAttachments"
          :keymonitor="keymonitor"
          )
</template>
<script>
import {mapState, mapActions} from "vuex";
import AttachFile from "@/components/attach-file/AttachFile";
import Multiselect from "vue-multiselect";

export default {
  name: "FormSchool",
  components: {
    Multiselect,
    AttachFile
  },
  props: {
    schoolInfo: {
      type: Object,
      default: () => ({})
    },
    requireErrors: {
      type: Object,
      default: () => ({})
    },
    keymonitor: {
      type: Function,
      default: () => {}
    },
    schoolCertificateAttachments: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState(["regionAreas"]),
    localSchoolInfo: {
      get() {
        return this.schoolInfo;
      },
      set(value) {
        this.keymonitor();
        this.$emit("onChangeValue", [value, "school_info"]);
      }
    },
    schoolRegion: {
      get() {
        return {
          value: this.schoolInfo.region
        };
      },
      set(value) {
        this.keymonitor();

        let newVal = "";
        if (value) {
          newVal = value.value;
        }
        this.$emit("on-change-school-region", newVal);
      }
    },
    showArea() {
      if (this.schoolRegion.value.toLowerCase().includes("татарстан")) {
        return true;
      }
      return false;
    },
    localSchoolCertificateAttachments: {
      get() {
        return this.schoolCertificateAttachments;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "school_certificate_attachments"]);
      }
    },
    areasList() {
      const arr = this.regionAreas.map((item) => item.name);
      return arr;
    }
  },
  data() {
    return {
      fields: {
        region: null
      },
      regionsList: [],
      interval: null,
      url: "suggest/address"
    };
  },
  methods: {
    ...mapActions(["getSuggetionDaData"]),

    changeAttachments(data) {
      this.$emit("onChangeValue", [data.value, data.fieldname]);
      this.keymonitor();
    },
    asyncFindSchoolRegion(query) {
      this.keymonitor();
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        const params = {
          query: query,
          count: 10,
          from_bound: {
            value: "region"
          },
          to_bound: {
            value: "region"
          }
        };
        this.getSuggetionDaData({
          data: params,
          url: this.url
        }).then(suggetion => {
          this.regionsList = suggetion.data.suggestions;
        });
        clearInterval(this.interval);
      }, 500);
    }
  }
};
</script>
